var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPhoneSmall(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5363",
    "data-name": "Group 5363",
    transform: "translate(-1210 -810)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1958",
    "data-name": "Rectangle 1958",
    width: 20,
    height: 20,
    transform: "translate(1210 810)",
    fill: "#3160d4",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "phone-call",
    d: "M20.357,15.4c-.055-.043-4.023-2.9-5.113-2.7-.52.092-.817.447-1.414,1.157-.1.115-.327.389-.506.585a8.345,8.345,0,0,1-1.1-.448A9.133,9.133,0,0,1,8.009,9.781a8.305,8.305,0,0,1-.448-1.1c.2-.18.471-.411.588-.509C8.856,7.577,9.211,7.28,9.3,6.759c.189-1.08-2.67-5.076-2.7-5.112A1.526,1.526,0,0,0,5.467,1C4.308,1,1,5.291,1,6.014c0,.042.061,4.311,5.325,9.667C11.675,20.939,15.944,21,15.986,21,16.709,21,21,17.692,21,16.533a1.522,1.522,0,0,0-.643-1.133Z",
    transform: "translate(1209 809)",
    fill: "#3160d4"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneSmall);
export default __webpack_public_path__ + "static/media/phoneSmall.5eda6ce2d5f7569286b6afd6046222bb.svg";
export { ForwardRef as ReactComponent };